// src/hooks/useLayoutMaster.js
import { useState, useEffect } from 'react';

export function useLayoutMaster() {
  const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  const isMobile = width <= 768;

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // --- THE GENERALIZED LAYOUT DEFINITIONS ---
  return {
    isMobile,
    
    // 1. Main Page Container
    container: (basePadding = '2rem') => ({
      maxWidth: '1400px',
      margin: '0 auto',
      padding: isMobile ? '1rem' : basePadding, // Auto-shrink padding
      width: '100%',
      overflowX: 'hidden' // Prevent side-scroll on phone
    }),

    // 2. The "Smart Grid" (Auto-collapses columns)
    // Usage: grid(4) -> 4 cols on desktop, 1 on mobile
    // Usage: grid('auto') -> auto-fit with smart min-width
    grid: (cols = 4, gap = '1.5rem') => {
      if (cols === 'auto') {
        return {
          display: 'grid',
          gridTemplateColumns: `repeat(auto-fit, minmax(${isMobile ? '300px' : '400px'}, 1fr))`,
          gap: isMobile ? '1rem' : gap
        };
      }
      return {
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : `repeat(${cols}, 1fr)`,
        gap: isMobile ? '1rem' : gap
      };
    },

    // 3. The "Smart Flex" (Switches Row -> Col)
    flexSection: (gap = '1.5rem') => ({
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: isMobile ? 'column' : 'row',
      gap: gap,
      alignItems: 'stretch'
    }),

    // 4. Flex Child helper (Fixes the charts getting squashed)
    flexChild: (desktopBasis = '1 1 auto') => ({
      flex: isMobile ? '1 1 auto' : desktopBasis,
      width: '100%'
    })
  };
}